import { useCallback } from 'react';
import { useLicensedStateContext } from 'src/contexts/LicensedStateContext';
import { filterPlacesByStates } from 'src/views/Coversheet/utils/filterPlacesByStates';

export function useFilterPlacesByLicensedStates() {
  const { statesWithSubmitPermission } = useLicensedStateContext();

  return useCallback(
    (results: google.maps.places.AutocompletePrediction[] | null) =>
      filterPlacesByStates(results, statesWithSubmitPermission),
    [statesWithSubmitPermission],
  );
}
